// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3B4Wz","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__LYCzB"};